/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const SecureIcon = /*#__PURE__*/ createSvgIcon(
  'SecureIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10 17.917c-.083 0-.167-.004-.25-.01a.789.789 0 01-.23-.053c-1.819-.597-3.277-1.701-4.374-3.312C4.049 12.93 3.5 11.174 3.5 9.27V5.52c0-.315.087-.599.26-.851.174-.252.407-.434.698-.545l5-1.917A1.5 1.5 0 0110 2.104c.18 0 .361.035.542.104l5 1.917c.291.111.524.293.698.545.173.252.26.536.26.85v3.75c0 1.904-.549 3.66-1.646 5.272-1.097 1.61-2.555 2.715-4.375 3.312a.79.79 0 01-.229.052c-.083.007-.167.01-.25.01zm0-1.48c1.444-.447 2.639-1.343 3.583-2.687A7.612 7.612 0 0015 9.27V5.52l-5-1.916-5 1.917v3.75c0 1.642.472 3.135 1.417 4.48.944 1.343 2.139 2.239 3.583 2.687z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default SecureIcon;
